import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BaseMessage, MessageImage, MessageTypes, PageState } from '../../modules/messages';
export const MessageAction = createActionGroup({
	source: 'Message',
	events: {
		// load: emptyProps(),
		loadAll: emptyProps(), //use to load both merket and mofid mesages
		load: props<{ messageType?: MessageTypes }>(),
		loading: props<{ messageType?: MessageTypes }>(),
		loadMofid: props<{ messageType?: MessageTypes }>(),
		loadingMofid: props<{ messageType?: MessageTypes; pageState: PageState }>(),
		loadMofidImage: props<{ imageId: string }>(),
		loadMoreMofid: emptyProps(),
		loaded: emptyProps(),
		loadedError: emptyProps(),
		loadHistory: props<{ symbolIsin: string }>(),
		set: props<{ messages: BaseMessage[]; messageType?: MessageTypes }>(),
		setMofidMessages: props<{ messages: BaseMessage[]; messageType?: MessageTypes; pageState: PageState }>(),
		read: props<{ messageType: MessageTypes; symbolIsin?: string }>(),
		readByIds: props<{ ids: string[] }>(),
		seenMessage: props<{ ids: string[] }>(),
		seenMessageByIsin: props<{ symbolIsin?: string }>(),
		hasSeen: emptyProps(),
		readed: props<{ ids: string[]; messageType?: MessageTypes }>(),
		seen: emptyProps(),
		delete: props<{ messageId: string }>(),
		add: props<{ message: BaseMessage }>(),
		update: props<{ message: BaseMessage }>(),
		updated: emptyProps(),
		addImage: props<{ image: MessageImage }>(),
		setImages: props<{ images: MessageImage[] }>(),
		subscribeToLs: emptyProps()
	}
});
